//region :: Imports ::
import MComponent from '../../Toolkit/Components/Component';
import {evalulateBool, MBoolean} from '../../Toolkit/Components/Controls/Control';
import {ReactElement, HTMLInputTypeAttribute, RefObject, createRef} from 'react';
import {InputNumber, InputNumberChangeParams} from 'primereact/inputnumber';
import {FieldProps} from 'formik';
import {MNullable, setFieldValue} from '../../Toolkit/Utils';
import {findDOMNode} from 'react-dom';

//endregion

/** */
export type MInputValueType = number;

/** */
type Props = {
    id: string;
    initialValue?: MInputValueType;
    type?: HTMLInputTypeAttribute;
    maxLength: number;
    mode?: 'decimal' | 'currency';
    currency?: string;
    placeholderText?: string;
    readonly?: boolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValue: MInputValueType) => void;
    decimalPlaces?: number;
    useGrouping?: boolean;
}

/** */
type State = {
    value: MInputValueType;
}

/** */
class MNumericBox extends MComponent<Props, State> {

    private readonly m_inputRef: RefObject<any>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.m_inputRef = createRef<any>();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.setFocus = this.setFocus.bind(this);
        this.input_onChange = this.input_onChange.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue === undefined ? 0 : this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private input_onChange(event: InputNumberChangeParams): void {
        this.setValue(event.value!);
    }

    /** */
    public setFocus(): void {

        setTimeout(() => {

            const element = findDOMNode(this.m_inputRef.current!) as MNullable<HTMLInputElement>;
            element?.focus();

        }, 200);

    }

    /** */
    public setValue(newValue: MInputValueType): void {

        this.safeSetState((draft: State) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <InputNumber id={this.props.id}
                         type={this.props.type === undefined ? 'text' : this.props.type}
                         maxLength={this.props.maxLength}
                         placeholder={this.props.placeholderText}
                         readOnly={this.props.readonly ?? false}
                         disabled={evalulateBool(this.props.disabled)}
                         className={this.props.className}
                         {
                             ...this.props.fieldProps?.field
                         }
                         value={this.state.value}
                         onChange={this.input_onChange}
                         ref={this.m_inputRef}
                         maxFractionDigits={this.props.decimalPlaces === undefined ? 0 : this.props.decimalPlaces}
                         mode={this.props.mode === undefined ? 'decimal' : this.props.mode}
                         currency={this.props.currency}
                         useGrouping={this.props.useGrouping === undefined ? false : this.props.useGrouping}/>
        );

    }

}

export default MNumericBox;
